import React from 'react'
//import PropTypes from 'prop-types'

const Filter = ({ car, filter, onChange }) => {
	const now = new Date()
	const setDate = (m,d,y) => new Date(m+"/"+d+"/"+y)
	const theFirst = d => { d = new Date(d); return new Date((d.getMonth()+1)+"/1/"+d.getFullYear())}
	const nextMonth = d => {d = new Date(d); return theFirst(new Date((theFirst(d)*1 )+ (31*86400000)))}
	const dateAdd = (d,x,i) => {
		const ticks = {
			s: 1000,
			m: 6000,
			h: 60000,
			d: 86400000,
		}
		return new Date((d*1) + (ticks[x]*i))
	}

	const fn = (f) => {
		let result = {start:null, end:null}
		const time = {
			year:now.getFullYear(),
			month:now.getMonth()+1,
			date:now.getDate(),
			day:now.getDay()
		}
		const today = setDate(time.month, time.date, time.year)
		switch(f){
			case "THIS_YEAR":
				result.start = setDate(1,1,time.year)
				result.end = new Date(setDate(1,1,time.year+1)-1)
				break;
			case "LAST_YEAR":
				result.start = setDate(1,1,time.year-1)
				result.end = new Date(setDate(1,1,time.year)-1)
				break;
			case "THIS_MONTH":
				result.start = theFirst(now)
				result.end = new Date(nextMonth(now)-1)
				break;
			case "LAST_MONTH": 
				result.start = theFirst(theFirst(now)-1)
				result.end = new Date(theFirst(now)-1)
				break;
			case "THIS_WEEK":
				result.start = dateAdd(today,"d",time.day*-1)
				result.end = new Date(dateAdd(today,"d",time.day-1)-1)
				break;
			case "LAST_WEEK":
				result.start = dateAdd(today,"d",(time.day+7)*-1)
				result.end = new Date(dateAdd(today,"d",time.day*-1)-1)
				break;
			default:
		}
		return result;
	}

	const changer = e => { 
    	e.preventDefault()
		const filter = e.target.value
		const date_range = fn(filter)
		onChange( car, filter, date_range.start*1, date_range.end*1 )
    }

  return (
  	<div className="filter">
  	<label>
  	Filter:
  	<select onChange={changer} defaultValue={filter.filter}>
  		<option value="SHOW_ALL">All Records</option>
  		<option value="SHOW_LAST_FILLUP">Last Fillup</option>
  		<option value="THIS_YEAR">This Year</option>
  		<option value="LAST_YEAR">Last Year</option>
  		<option value="THIS_MONTH">This Month</option>
  		<option value="LAST_MONTH">Last Month</option>
  		<option value="THIS_WEEK">This Week</option>
  		<option value="LAST_WEEK">Last Week</option>
  	</select>
  	</label>
  	</div>
  )
}
 
export default Filter


// WEBPACK FOOTER //
// ./src/components/Filter/index.js